/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Review_Prompt_NegativeInputs */

const en_mobile_review_prompt_negative = /** @type {(inputs: Mobile_Review_Prompt_NegativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not really`)
};

const es_mobile_review_prompt_negative = /** @type {(inputs: Mobile_Review_Prompt_NegativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No mucho`)
};

/**
* | output |
* | --- |
* | "Not really" |
*
* @param {Mobile_Review_Prompt_NegativeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_review_prompt_negative = /** @type {((inputs?: Mobile_Review_Prompt_NegativeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Review_Prompt_NegativeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_review_prompt_negative(inputs)
	return en_mobile_review_prompt_negative(inputs)
});